var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 19,
  fill: "none",
  viewBox: "0 0 22 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.6 6.005h-1.2v6.6h1.2zm-1.2 7.801v1.2h1.2v-1.2zM11 .028.347 18.005h21.306zm0 2.354 8.547 14.423H2.453z"
})));
export default SvgInfoTriangle;